import {WebStorageUtility} from "./webstorage-utiltiy";

export function LocalStorage(key?: string) {
  return WebStorage(localStorage, key);
}

export function SessionStorage(key?: string) {
  return WebStorage(sessionStorage, key);
}

export let WebStorage = (webStorage: Storage, key: string) => {
  return (target: Object, propertyName: string): void => {
    key = key || propertyName;

    const storedValue = WebStorageUtility.get(webStorage, key);

    Object.defineProperty(target, propertyName, {
      get: function () {
        return WebStorageUtility.get(webStorage, key);
      },
      set: function (value: any) {
        WebStorageUtility.set(webStorage, key, value);
      },
    });
  };
};



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/storage/storage-decorator.ts